import SuccessImg from "assets/img/success_img.png";
import NavButton from "components/ui/Button/NavButton";
import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router";
import { StageIds } from "utils/constants";

const Success = () => {
  const navigate = useNavigate();
  const { user, rule, currentStep, dates, tutorial, signOut } = useAuth();

  return (
    <>
      <div className="flex flex-col items-center justify-between mx-4 gap-9 md:flex-row md:mx-0">
        <div className="flex-1">
          <h2 className="mb-3 text-[32px] font-bold text-black-bb font-title">
            Sua realização foi cadastrada
            <br /> no Prêmio BB 2024!
          </h2>
          <div className="flex flex-col gap-5 mt-16 mb-5 content">
            <p>
              No período de 08 a 19 de março, você e os demais funcionários com
              acordo do Tipo Híbrido no Conexão participarão da primeira etapa
              de votação do Prêmio BB 2024.
            </p>
            <p>
              {" "}
              Neste período, você e os funcionários da sua Unidade poderão votar
              nas 3 iniciativas mais relevantes para a Unidade, dentre todas
              apresentadas.
            </p>
            <p>
              <strong>Fique ligado e não perca o prazo da votação.</strong>
            </p>
          </div>

          <NavButton
            text="Ver realizações"
            bgColor="#FCFC30"
            onClick={() => {currentStep?._id === StageIds.STAGE_INSCRICAO
              ? navigate("/realizations")
              : navigate("/evaluation");}}
          />
        </div>
        <div className="flex-1">
          <img
            width={"100%"}
            src={SuccessImg}
            alt=""
            className="relative top-8"
          />
        </div>
      </div>
    </>
  );
};

export default Success;
